/* ==========================================================================
   Elvaro – tiroir panier
   Portage du tiroir de Netoreille. La logique de regroupement par packs
   (« X boîtes ») et la barre de franchise de port n'ont pas été reprises :
   Elvaro vend une seule référence, en trois coloris, et la livraison est
   offerte sans palier.
   Reste donc : la pastille « -XX % » à côté du prix, calculée à partir du
   prix barré réellement affiché par le thème, et le compteur du titre.
   ========================================================================== */
(function () {
  'use strict';

  function parseMoney(text) {
    if (!text) return NaN;
    var raw = text.replace(/[^\d.,]/g, '');
    if (!raw) return NaN;
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var dec = lastComma > lastDot ? ',' : '.';
    var thou = dec === ',' ? '.' : ',';
    raw = raw.split(thou).join('').replace(dec, '.');
    var v = parseFloat(raw);
    return isNaN(v) ? NaN : v;
  }

  /* Pastille « -XX % » : on ne l'affiche que si le thème montre vraiment
     un prix barré supérieur au prix payé. Rien n'est inventé. */
  function decorate() {
    document
      .querySelectorAll('.cart-drawer .cart-drawer-item .cart-item__discounted-prices')
      .forEach(function (group) {
        var old = group.querySelector('.cart-item__old-price, .compare-price');
        var now = group.querySelector('.regular-price, .cart-item__final-price');
        var existing = group.querySelector('.nd-off');

        function drop() {
          if (existing) existing.remove();
        }

        if (!old || !now) return drop();

        var o = parseMoney(old.textContent);
        var n = parseMoney(now.textContent);
        if (!(o > 0) || isNaN(n) || n >= o) return drop();

        var pct = Math.round((1 - n / o) * 100);
        if (pct < 1) return drop();

        var label = '-' + pct + ' %';
        if (existing) {
          if (existing.textContent !== label) existing.textContent = label;
          return;
        }

        var badge = document.createElement('span');
        badge.className = 'nd-off';
        badge.textContent = label;
        now.insertAdjacentElement('afterend', badge);
      });
  }

  /* Compteur du titre « Votre panier (n) » : n = nombre d'articles. */
  var attente = null;

  function majCompteurs() {
    if (attente) clearTimeout(attente);
    attente = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = c.item_count;
          document.querySelectorAll('.nd-count').forEach(function (e) {
            if (e.textContent !== String(n)) e.textContent = n;
          });
        })
        .catch(function () {});
    }, 250);
  }

  var queued = false;
  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      try {
        decorate();
      } catch (e) {}
    });
  }

  function tout() {
    refresh();
    majCompteurs();
  }

  function start() {
    tout();
    var target = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(tout).observe(target, { childList: true, subtree: true });
    ['cart:refresh', 'cart:updated'].forEach(function (evt) {
      document.addEventListener(evt, tout);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
